import { Button, DatePicker, Form, Input, Select } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import {
  filterOption,
  normalizeDate,
  periodMap,
} from 'src/pages/finSystem/balanceSummary/reports/utils'
import { PERIOD_OPTIONS } from 'src/pages/finSystem/balanceSummary/reports/const'
import {
  DividendFilter,
  FormValue,
} from 'src/pages/finSystem/balanceSummary/reports/reportDividends/types'
import { useWalletOptions } from 'src/pages/finSystem/balanceSummary/reports/reportDividends/hook'

type Props = {
  filters: DividendFilter
  setFilters: (values: Partial<DividendFilter>) => void
  resetFilters: () => void
  initialValueForm: FormValue
}

export const DividendListFilter = ({
  filters,
  setFilters,
  resetFilters,
  initialValueForm,
}: Props) => {
  const { walletOptions } = useWalletOptions()
  const [form] = Form.useForm()
  const { RangePicker } = DatePicker
  const { Item } = Form

  const handleChangeForm = (valueField: Record<string, any>) => {
    const [key, value] = Object.entries(valueField)[0]

    if (key === 'search' && value.length < 3 && value.length > 0) return

    if (key === 'periodDatePicker') {
      const [dateFromPicker, dateToPicker] = value ?? []
      const dateFrom = normalizeDate(dateFromPicker)
      const dateTo = normalizeDate(dateToPicker)
      setFilters({ dateFrom, dateTo })
    }

    if (key === 'period') {
      const { dateFrom, dateTo } = periodMap[value] ?? {}
      setFilters({ dateFrom, dateTo })
    }

    if (key === 'walletIds' || key === 'search') {
      setFilters({ [key]: value })
    }
  }

  const checkVisibleReset = () => {
    const keys = Object.keys(filters)
    if (keys.length === 0) {
      return false
    }
    if (keys.length === 1 && keys[0] === 'sorterField') {
      return false
    }
    return true
  }

  const period = Form.useWatch('period', form)
  return (
    <Form
      form={form}
      layout="inline"
      onValuesChange={handleChangeForm}
      initialValues={initialValueForm}
    >
      <Item name="search" key="searchText" style={{ width: 280 }}>
        <Input
          placeholder="Search"
          allowClear
          prefix={
            <SearchOutlined
              style={{ color: 'var(--color-gray-60)', fontSize: 12 }}
            />
          }
        />
      </Item>

      <Item name="walletIds" key="walletIds" style={{ width: 230 }}>
        <Select
          placeholder="Wallets"
          mode="multiple"
          options={walletOptions}
          filterOption={filterOption}
        />
      </Item>

      <Item name="period" key="period" style={{ width: 150 }}>
        <Select placeholder="Period" options={PERIOD_OPTIONS} allowClear />
      </Item>

      {period === 'date_range' && (
        <Item
          name="periodDatePicker"
          key="periodDatePicker"
          style={{ width: 180 }}
        >
          <RangePicker style={{ width: 250 }} />
        </Item>
      )}
      {checkVisibleReset() && (
        <Item style={{ marginLeft: period === 'date_range' ? 70 : 0 }}>
          <Button
            onClick={() => {
              form.setFieldsValue({
                search: undefined,
                walletIds: undefined,
                period: undefined,
                periodDatePicker: undefined,
              })
              resetFilters()
            }}
          >
            Reset filters
          </Button>
        </Item>
      )}
    </Form>
  )
}
